module.exports = __webpack_public_path__ + "img/rs.274dbc27.svg";